import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { KEY_N } from '@/constants';
import { checkCtrlPressed, checkAltPressed, isActiveElementEditable } from '@/helpers';
import { callN1FunctionThunk } from '@/store/actions/n1-function';

export default () => {
  const dispatch = useDispatch();

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  const handleKeyDown = event => {
    if (!isActiveElementEditable()) {
      const isCtrlPressed = checkCtrlPressed(event);
      const isAltPressed = checkAltPressed(event);
      const isCombinationPressed =
        isCtrlPressed && isAltPressed && event.code === KEY_N;

      if (isCombinationPressed) {
        event.preventDefault();
        dispatch(callN1FunctionThunk());
      }
    }
  };
};
